import React from 'react';
/*
import {
  hf,
  hfDTM,
  ht,
  cr,
  a,
  l,
  BoxC,
  CbxC,
  IptC,
  LblC,
  GridC,
  TextC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as IptC from "./_ccbIptC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as CbxC from "./_cccCbxC";
import * as LblC from "./_cccLblC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ls from "./_csLcl"; // local state
import * as ht from './_ht';
import * as hf from './_hf';

import * as icm from './icm';
import * as ihd from './ihd';

export const N = (pz: {
  sPz: ht.dz,
  boxStlz: ht.dz,
  cz: {
    i1zz: ht.dz,
    i17rs: ht.ls,
    onChgAsync: () => void,
  }
}) => {

  const _frcUdt = ls.frcUdt();

  const _udtI1z3z = async () => {
    if (pz.cz.onChgAsync) await pz.cz.onChgAsync();
    _frcUdt();
  }

  //hf.l(`icvI1zS11Co3d 38: ${pz.cz.i1zz?.i1zrz.i1zrs1100i}, ${pz.cz.i1zz?.i1z3z.i1z3s2100i}`);
  return (
    cr.c(BoxC.N, {
      key: 'Iccv23b4b.root',
      boxStlz: {
        ... a('dw/f'),
        ... pz.boxStlz
      },
      oClds: [

        cr.c(GridC.N, {
          key: -30,
          abtType: 'nolineCmnz',
          lineCs: [
            {
              boxStlz: a(`bc/gn7 bwb/1 mb/1 pb/1 sc/gn1`),
              cellCs: [
                {
                  boxStlz: a(`f/2`),
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        abtType: 'hzlStfz',
                        boxStlz: a('dw/18'),
                        textz: {
                          pfx: 'その他支払内容：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: pz.cz.i1zz?.i1z3z.i1z3a1100s,
                              onChg: ( _s: ht.s ) => {
                                pz.cz.i1zz.i1z3z.i1z3a1100s = _s;
                              }
                            }
                          })

                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        textz: {
                          pfx: '金額：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            iptStlz: a('ta/r tb'),
                            cz: {
                              bEdit:
                                hf.i(pz.sPz.crt.phs, ['crt', 'udt']) &&
                                pz.cz.i1zz.i1zrz.i1zrs1100i != 90,
                              iptType: 'text',
                              vle: pz.cz.i1zz?.i1z3z.i1z3m3100i,
                              grtPfx: (_s: ht.s) => hf.cvtCmm(hf.n(_s)),
                              onChg: ( _s: ht.s ) => {
                                pz.cz.i1zz.i1z3z.i1z3m3100i = Number(_s);
/*
                                const _dz = icm.grtI1z3z({
                                  i1zz: pz.cz.i1zz,
                                  i17rs: pz.cz.i17rs,
                                });
                                hf.udtDz(pz.cz.i1zz?.i1z3z, _dz);
*/
                                icm.udtI1z3z({
                                  i1zz: pz.cz.i1zz,
                                  i17rs: pz.cz.i17rs,
                                });
                                _udtI1z3z();
                              }
                            }
                          }),
                          cr.c(TextC.N, {
                            key: -20,
                            abtType: 'bsdCmnz',
                            textz: {
                              pfx: '円',
                            },
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  boxStlz: a('f/2'),
                  oClds: [
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      boxStlz: a('pl/2 sc/rd5'),
                      lblCz: {
                        textz: {
                          pfx: '支払額合計：',
                          stlz: a('tc/lt1'),
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            iptStlz: a(`ta/r tc/lt1`),
                            cz: {
                              bEdit: false,
                              iptType: 'text',
                              vle: pz.cz.i1zz?.i1z3z.i1z3m4100i,
                              grtPfx: (_s: ht.s) => hf.cvtCmm(hf.n(_s)),
                            }
                          }),
                          cr.c(TextC.N, {
                            key: -20,
                            abtType: 'bsdCmnz',
                            textz: {
                              pfx: '円',
                              stlz: a('ta/r tb tc/lt1'),
                            },
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`bc/gn7 bwb/1 pb/1 mb/1`),
              cellCs: [
                {
                  boxStlz: a(`f/1.5`),
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        boxStlz: a(`dw/12`),
                        textz: {
                          pfx: '予約状況：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(CbxC.MS, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              ls: [
                                { key: 80, pfx: '仮予約' },
                                { key: 90, pfx: '本予約' },
                              ],
                              vle: 
                                pz.cz.i1zz?.i1zrz.i1zrs1100i == 70 ? 80 : pz.cz.i1zz?.i1zrz.i1zrs1100i, // 仮押は仮予約として表示
                              onChg: (_key: ht.n) => {
                                icm.udtI1zrs1100i({
                                  i1zz: pz.cz.i1zz, 
                                  i1zrs1100i: _key
                                });
                                _frcUdt();                                
                              }
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        abtType: 'hzlStfz',
                        boxStlz: a('dw/10'),
                        textz: {
                          pfx: '受領日：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'dtm',
                              vle: pz.cz.i1zz?.i1z3z.i1z3d2100s,
                              onChg: ( _s: ht.s ) => {
                                pz.cz.i1zz.i1z3z.i1z3d2100s = _s;
                                icm.udtI1z3z({
                                  i1zz: pz.cz.i1zz,
                                  i17rs: pz.cz.i17rs,
                                });
                                if ( pz.cz.i1zz?.i1z3z.i1z3s1100i == 40 ) {
                                  pz.cz.i1zz.i1zrz.i1zrs1100i = 90;
                                }
                                _udtI1z3z();
                              }
                            }
                          })

                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        abtType: 'hzlStfz',
                        boxStlz: a('dw/12'),
                        textz: {
                          pfx: '支払方法：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'pcr',
                              ls: ihd.f('i1z3t3100i').ls,
                              vle: pz.cz.i1zz?.i1z3z.i1z3t3100i,
                              onChg: ( _dz: ht.dz ) => {
                                pz.cz.i1zz.i1z3z.i1z3t3100i = _dz.key;
                              }
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        abtType: 'hzlStfz',
                        boxStlz: a('dw/12'),
                        textz: {
                          pfx: '返金状況：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              //bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              bEdit: false,
                              iptType: 'pcr',
                              ls: ihd.f('i1z3s2100i').ls,
                              vle: pz.cz.i1zz?.i1z3z.i1z3s2100i,
                              /*
                              onChg: ( _dz: ht.dz ) => {
                                pz.cz.i1zz.i1z3z.i1z3s2100i = _dz.key;
                                if (pz.cz.i1zz.i1z3z.i1z3s2100i == 20) pz.cz.i1zz.i1zrz.i1zrs1100i = 22;
                                if (pz.cz.i1zz.i1z3z.i1z3s2100i == 30) pz.cz.i1zz.i1zrz.i1zrs1100i = 24;
                                if (pz.cz.i1zz.i1z3z.i1z3s2100i == 10) pz.cz.i1zz.i1zrz.i1zrs1100i = 26;
                              }
                               */
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
          ]
        })

      ]
    })
  );
};
 